import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

const API = '/api/v1/kasir/engagement/inko-creation';

function createKasirInkoCreationLibrary() {
  return {
    tab: 'assets',
    assets: [],
    categories: [],
    fonts: [],
    templates: [],
    printOrders: [],
    assetTypes: [],
    licenses: [],
    productKeys: [],
    fontCategories: [],
    fontStyles: [],
    accessLevels: ['free', 'pro'],
    productionStatuses: [],
    modalAsset: false,
    modalFont: false,
    saving: false,
    tagsText: '',
    orderFilter: '',
    assetForm: {
      id: null,
      name: '',
      description: '',
      type: 'logo',
      category_id: '',
      license: 'official',
      has_transparency: true,
      file: null,
    },
    fontForm: { id: null, name: '', family: '', category: 'sans', access: 'free', file: null },

    init() {
      const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
      const keys = [
        'assets', 'categories', 'fonts', 'templates', 'assetTypes', 'licenses',
        'productKeys', 'fontCategories', 'fontStyles', 'accessLevels', 'productionStatuses',
      ];
      keys.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(cfg, key)) {
          this[key] = cfg[key];
        }
      });
    },

    openCreate() {
      if (this.tab === 'assets') {
        this.assetForm = {
          id: null,
          name: '',
          description: '',
          type: 'logo',
          category_id: this.categories[0]?.id || '',
          license: 'official',
          has_transparency: true,
          file: null,
        };
        this.tagsText = '';
        this.modalAsset = true;
      } else if (this.tab === 'fonts') {
        this.fontForm = { id: null, name: '', family: '', category: 'sans', access: 'free', file: null };
        this.modalFont = true;
      } else if (this.tab === 'templates') {
        window.toast?.('Template custom: gunakan API atau hubungi dev untuk editor zones.', 'info');
      } else if (this.tab === 'orders') {
        this.reloadOrders();
      }
    },

    editAsset(a) {
      this.assetForm = {
        id: a.id,
        name: a.name,
        description: a.description || '',
        type: a.type,
        category_id: a.category_id || '',
        license: a.license || 'official',
        has_transparency: !!a.has_transparency,
        file: null,
      };
      this.tagsText = (a.tags || []).join(', ');
      this.modalAsset = true;
    },

    assetPayload() {
      const fd = new FormData();
      fd.append('name', this.assetForm.name);
      fd.append('description', this.assetForm.description || '');
      fd.append('type', this.assetForm.type);
      if (this.assetForm.category_id) fd.append('category_id', this.assetForm.category_id);
      fd.append('license', this.assetForm.license);
      fd.append('has_transparency', this.assetForm.has_transparency ? '1' : '0');
      this.tagsText.split(',').map(s => s.trim()).filter(Boolean).forEach(t => fd.append('tags[]', t));
      if (this.assetForm.file) fd.append('file', this.assetForm.file);
      return fd;
    },

    async saveAsset() {
      this.saving = true;
      try {
        const fd = this.assetPayload();
        if (this.assetForm.id) {
          fd.append('_method', 'PUT');
          await axios.post(`${API}/assets/${this.assetForm.id}`, fd);
        } else {
          await axios.post(`${API}/assets`, fd);
        }
        await this.reloadAssets();
        this.modalAsset = false;
        window.toast?.('Aset disimpan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan aset.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async removeAsset(a) {
      if (!confirm('Arsipkan aset ini?')) return;
      try {
        await axios.delete(`${API}/assets/${a.id}`);
        this.assets = this.assets.filter(x => x.id !== a.id);
        window.toast?.('Aset diarsipkan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },

    editFont(f) {
      this.fontForm = { id: f.id, name: f.name, family: f.family, category: f.category || 'sans', access: f.access || 'free', file: null };
      this.modalFont = true;
    },

    async saveFont() {
      this.saving = true;
      try {
        const fd = new FormData();
        fd.append('name', this.fontForm.name);
        fd.append('family', this.fontForm.family);
        fd.append('category', this.fontForm.category);
        fd.append('access', this.fontForm.access);
        if (this.fontForm.file) fd.append('file', this.fontForm.file);
        if (this.fontForm.id) {
          fd.append('_method', 'PUT');
          await axios.post(`${API}/fonts/${this.fontForm.id}`, fd);
        } else {
          await axios.post(`${API}/fonts`, fd);
        }
        await this.reloadFonts();
        this.modalFont = false;
        window.toast?.('Font disimpan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyimpan font.', 'error');
      } finally {
        this.saving = false;
      }
    },

    async removeFont(f) {
      if (!confirm('Hapus font ini?')) return;
      try {
        await axios.delete(`${API}/fonts/${f.id}`);
        this.fonts = this.fonts.filter(x => x.id !== f.id);
        window.toast?.('Font dihapus.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },

    editTemplate() {},

    async reloadAssets() {
      const { data } = await axios.get(`${API}/assets?scope=system&per_page=100`);
      this.assets = data.data || [];
    },

    async reloadFonts() {
      const { data } = await axios.get(`${API}/fonts`);
      this.fonts = data.data || [];
    },

    async reloadOrders() {
      const params = this.orderFilter ? { production_status: this.orderFilter } : {};
      const { data } = await axios.get(`${API}/print-orders`, { params });
      this.printOrders = data.data || [];
    },

    async advanceOrder(o) {
      const status = prompt('Status produksi baru (queued, prepress, printing, finishing, quality_check, ready, shipped, completed):', o.production_status);
      if (!status) return;
      try {
        await axios.post(`${API}/print-orders/${o.id}/advance`, { status, note: 'Update dari panel kasir' });
        await this.reloadOrders();
        window.toast?.('Status order diperbarui.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal update status.', 'error');
      }
    },
  };
}

Alpine.data('kasirInkoCreationLibrary', createKasirInkoCreationLibrary);
